export const IC_DOC_ENVIRONMENT = "https://icdoc.sharepoint.com/KlantEvaluatie/Forms/Klantevaluaties%202022.aspx";
